import TilesPrayerContainer from "@/components/tiles-prayer-container/TilesPrayerContainer";
import prayerIcon from "@/img/prayer-icon.svg";
import Skeleton from "@/components/skeletons/Skeleton";

import { useSelect } from "@wordpress/data";
import { formatCurrentDate } from "@/helpers/format-date";
import { WeatherSelect } from "@/store/type";
import { WEATHER_STORE } from "@/store/store";
import { formatDailyTimedEvents } from "@/helpers/format-prayer-tide";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "@/hooks/use-window-resize";
import { getCurrentLanguage } from "@/helpers/get-current-langage";

import "./style.scss";

export const App = () => {
	const { t } = useTranslation();

	const width = useWindowSize();
	const lang = getCurrentLanguage();

	const { prayerData, isLoading, error } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) =>
			select(WEATHER_STORE).getPrayerState(),
		[],
	);

	const formatData = formatDailyTimedEvents(
		prayerData,
		lang,
		"prayer",
		new Date(),
		true,
	);

	return isLoading ? (
		<Skeleton
			className="tiles-prayer-container"
			length={1}
			height={300}
			width={width > 600 ? 600 : 300}
		/>
	) : error ? (
		<p>{t("fetchError")}</p>
	) : (
		<div className="prayer-app">
			<TilesPrayerContainer
				showCurrentType={false}
				title={t("prayerTimes")}
				info={formatCurrentDate({ date: new Date(), lang })}
				icon={<img src={prayerIcon} alt="prayer" />}
				data={formatData}
			/>
		</div>
	);
};

export default App;
